export default __webpack_public_path__ + "static/media/tooltipIcon.dbf9e53f.svg";